import '@fancyapps/fancybox'
import {getHistoryBanner} from '../history-banner'

export function setFancyboxSettings()
{
  $.fancybox.defaults.backFocus = false
  $.fancybox.defaults.beforeShow = () => {
    document.querySelector('.js-header')?.classList.add('compensate-for-scrollbar')
  }
  $.fancybox.defaults.afterClose = () => {
    document.querySelector('.js-header')?.classList.remove('compensate-for-scrollbar')
  }

  document.querySelectorAll('.js-history-fancybox').forEach(el => {
    const imageEl = el.querySelector('.js-history-fancybox-image')
    const captionEl = el.querySelector('.js-history-fancybox-caption')
    $(imageEl).fancybox({
      caption: () => {
        return captionEl?.innerHTML
      }
    })
  })

  document.querySelectorAll('.js-history-fancybox-banner').forEach(bannerLink =>
    bannerLink.addEventListener('click', e => {
      e.preventDefault()
      getHistoryBanner(bannerLink.dataset.bannerId)
        .then(banner => $.fancybox.open(banner))
    })
  )
}
